import { create } from 'zustand';
import { RouteObject } from 'react-router-dom';

// Define Zustand store for dynamic routes
interface RouteStore {
  routes: RouteObject[];
  addRoute: (newRoute: RouteObject) => void;
}

export const useRouteStore = create<RouteStore>((set) => ({
  routes: JSON.parse(localStorage.getItem('dynamicRoutes') || '[]'),
  addRoute: (newRoute) =>
    set((state) => {
      const updatedRoutes = [...state.routes, newRoute];
      localStorage.setItem('dynamicRoutes', JSON.stringify(updatedRoutes)); // Persist routes
      return { routes: updatedRoutes };
    }),
}));
